import { inject, injectable } from 'inversify';
import { computed, makeObservable } from 'mobx';
import type { BannerVariant, BannerContent } from '@/components/banner/Banner';
import { TYPES } from '@/engine/ioc';
import { BannerStore } from './Banner.store';

@injectable()
export class BannerController {
  private readonly _bannerStore: BannerStore;

  public constructor(@inject(TYPES.BannerStore) bannerStore: BannerStore) {
    this._bannerStore = bannerStore;
    makeObservable(this);
  }

  @computed
  public get variant(): BannerVariant | null {
    return this._bannerStore.variant;
  }

  @computed
  public get content(): BannerContent {
    return this._bannerStore.content;
  }

  @computed
  public get isVisible(): boolean {
    return this._bannerStore.isVisible;
  }

  @computed
  public get bannerProps(): { variant: BannerVariant; content: BannerContent } | null {
    return this._bannerStore.currentBanner;
  }

  public close(): void {
    this._bannerStore.hideBanner();
  }
}
